import { render, staticRenderFns } from "./PreCase.vue?vue&type=template&id=dcb2b8c6&scoped=true&"
import script from "./PreCase.vue?vue&type=script&lang=js&"
export * from "./PreCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb2b8c6",
  null
  
)

export default component.exports